import styled from '@emotion/styled';

export const StyledContent = styled.div({
    maxWidth: 650,
    width: '100%',
});

export const StyledIframeContainer = styled.div({
    display: 'flex',
    justifyContent: 'center',
    minHeight: '65vh',
});
